import React from 'react';
import axios from 'axios';

//functions
import {AddContact} from '../functions/AddCheckedToFirebase';
// import { Redirect } from 'react-router';

//blueprint
// import { Position,  Intent, Toaster } from "@blueprintjs/core";

// const AppToaster = Toaster.create({
//     className: "deleted-contact",
//     position: Position.TOP,
// });

// const showToast = (index) => {
//     AppToaster.show({ message: `Contact ${index} is ready`, intent: Intent.SUCCESS, timeout: 1000});
// }

const ContactsForProsp = ({contacts, fbProfile, auth, setShowSpinn}) => {


    const handleClick = (contacts) => {
        var arrConLink = [];
        contacts.map((contact) =>{
            return contact.contactLinkedin ? arrConLink.push(contact.contactLinkedin) : null
        })
        sendToServer(arrConLink)
        setShowSpinn(true)
    }

    const sendToServer = (arrConLink) => {
        var checkedContacts = [];
        
        for (let index = 0; index < arrConLink.length; index++) {
            const element = arrConLink[index];
            
            let data= { input: element }
            axios
            .post("https://boundapiv2.herokuapp.com/LIprofile", data)
            .then((response) => {
                checkedContacts.push(response)
                //int
                handleInterests(response.data, element, auth, fbProfile)
                //showToast(index)
                // console.log(index, arrConLink.length);
            })
            .then(()=>{
                if(index === arrConLink.length-1){
                    // setShowSpinn(false)
                } 
            })
        }
    }

    const handleInterests = ( profile, url ) =>{
        let major = ['']
        let summary = ''
    
        if(profile?.education?.length > 0){
            profile?.education.map(edu =>{
                let arr = []
                major = arr
                return(
                    arr.push(edu.field_of_study)
                )
            })
        }
    
        if(profile.summary !== ''){
            summary = profile.summary
        }
    
        major.join(' ')
        let inputText = `${summary} ${major}.`
        let content = inputText.replace(/\n/g, "")
    
        //function
        getInterests( content, profile, url )
        //checkArticles(profile)
    }
    
    const getInterests = ( content, profile, url ) =>{

        const message= { Input: content };
    
        axios
        .post('https://boundapiv2.herokuapp.com/LIinterests', message)
        .then((response) => {
    

            let sendArr = []
            
            if(content?.length > 20){
            let arr = response.data.split("\n")
            
            for(let i = 0; i < arr.length; i++){
                let int = arr[i].substring(3)
                if (int !== 'null' && int !== "" && int !== 'null ' && int !== ' null'){
                    sendArr.push(int)
                }
            }
            } else {
                 sendArr =''
            }

            AddContact(fbProfile, profile, url, sendArr, auth, content)
            setShowSpinn(false)
        }, (error) => {
        console.log(error);
        })
    }

    // const checkArticles = (profile) => {
    //     if(profile.articles.length > 0){

    //         profile.articles.map(article => {
    //             const body = {link: article.link}
    //             var arrRes = [];
                
    //             axios.post('http://localhost:4000/articleExtract', body)
    //             .then((response) => {
    //                 console.log(response)
    //                 arrRes.push(response)
    //             })
    //             return arrRes
    //         })
    //     }
    // }

    return (
        <div>
            <button 
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 my-2 rounded ml-4 focus:outline-none focus:ring focus:border-indigo-300 disabled:opacity-50"
                onClick={()=>handleClick(contacts)}
            >
                Search For Prospects
            </button>
        </div>
    )
}

export default ContactsForProsp
